
<template id='contact'>
	<div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
        <b-container>
            <div class="header-body text-center mb-4">
            <b-row class="justify-content-center">
                <b-col xl="5" lg="6" md="8" class="px-5">
                <h1 class="text-white">Need to Talk to Us?</h1>
                </b-col>
            </b-row>
            </div>
        </b-container>
        <div class="separator separator-bottom separator-skew zindex-100">
            <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
                xmlns="http://www.w3.org/2000/svg">
            <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
            </svg>
        </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5 text-white">
        <b-row>
            <b-col col="12">
                <h2 class="text-uppercase ls-1 py-3 mb-0 text-white font-weight-bold mb-0">Email or Text us anytime! </h2>
                <strong class="text-primary py-3 mb-0">We’d love to hear from you. Let us know how we can help you today.</strong>
            </b-col>
        </b-row>
    </b-container>
    <div class="clearfix"></div>
    <b-container class="pb-5 text-white">
        <b-row>
            <b-col col="12">
                <h3 class="text-white font-size-large">You’ll feel like we are part of your team but you won’t have to put us on your payroll. We’re that vested in making sure that you’re successful!</h3>
            </b-col>
        </b-row>
        <b-row >
            <b-col md="6">
              <b-card no-body>
                <b-card-body >
                  <div class="icon icon-shape bg-gradient-red text-white rounded-circle shadow mb-4">
                    <i class="fa fa-database"></i>
                  </div>
                  <h5 class="h3">Try our self service portal</h5>
                  <p><a href="https://support.devopsintegration.io" target="_blank">support.devopsintegration.io</a></p>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col md="6">
              <b-card no-body>
                <b-card-body >
                  <div class="icon icon-shape bg-gradient-red text-white rounded-circle shadow mb-4">
                    <i class="fa fa-envelope"></i>
                  </div>
                  <h5 class="h3">Email us at:</h5>
                  <p><a href="mailto:support@devopsintegration.io" target="_blank">support@devopsintegration.io</a></p>
                </b-card-body>
              </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col col="12">
                <h2 class="text-white p-2 mt-2 bg-gradient-primary font-size-large">Or We’re here for you!</h2>
                
            </b-col>
        </b-row>
    </b-container>
    
    <!-- Contact Section End -->
    <PricingQuote :contact="false" :quote="true"></PricingQuote>

	</div>
</template>
<script>
import PricingQuote from '@/components/pricing-quote/pricing-quote.vue'
export default {
	name: 'contact',
	components:{PricingQuote}
}
</script>
<style scoped>

</style>